import React, { createContext, useContext, useState } from 'react';

const PaginaClienteContext = createContext();

export const PaginaClienteProvider = ({ children }) => {


  const defaultUser = {
    adm: false,
    nome: ''
  };

  const defaultContatos = {
    nome: "",
    email: "",
    telefone: "",
    id: null,
    tipo: ''
  }

  const defaultValues = {
    cnpj: '',
    razaoSocial: '',
    nomeFantasia: '',
    codigoCliente: '',
    cidade: '',
    estado: '',
    anexos: [],
    observacao: '',
    observacoes: []

  }

  const [usuario, setUsuario] = useState(defaultUser);
  const [cliente, setCliente] = useState(defaultValues);
  const [comprador, setComprador] = useState({ ...defaultContatos, tipo: 0 });
  const [financeiro, setFinanceiro] = useState({ ...defaultContatos, tipo: 1 });
  const [entrega, setEntrega] = useState({ ...defaultContatos, tipo: 2 });
  const [anexos, setAnexos] = useState([])
  const [activeIndex, setActiveIndex] = useState(2);
  const [cel, setCel] = useState({
    comprador: true,
    financeiro: true,
    entrega: true
  })


  const value = {
    usuario,
    setUsuario,
    cliente,
    setCliente,
    comprador,
    setComprador,
    financeiro,
    setFinanceiro,
    entrega,
    setEntrega,
    anexos,
    setAnexos,
    activeIndex,
    setActiveIndex,
    cel,
    setCel,
    defaultValues, defaultContatos
  };

  return (
    <PaginaClienteContext.Provider value={value}>
      {children}
    </PaginaClienteContext.Provider>
  );
}

export const usePaginaClienteContext = () => {
  const context = useContext(PaginaClienteContext);
  if (!context) {
    throw new Error('useProductContext deve ser usado com um ProdutoProvider');
  }
  return context;
}
